import { readable,derived } from 'svelte/store'
import { urlServeur } from '../components/conf.js'

export const coffreByBq = readable(null, function start(set) {
    fetch(urlServeur + "/api/immeubles/oplistebybk")
        .then(function (response) {
            if (!response.ok) {
                throw new Error('unable to load opvcm on opvcm store init');
            }
            return response.json();
        })
        .then(function (data) {
            const opvcm = data.payload;
           // console.log('Opvcm_bk suite =>')
            //console.log(opvcm)
            set(opvcm);
        });

    return function stop() {
        console.log('opvcm by bq Store Stopped');
    };
});


/**
 * Recupere les date immeuble et opvcm à laa suite
 */
export const coffre = readable(null, function start(set) {
    fetch(urlServeur + "/api/immeubles/alldata")
        .then(function (response) {
            if (!response.ok) {
                throw new Error('unable to load opvcm on opvcm store init');
            }
            return response.json();
        })
        .then(function (data) {
            const opvcm = data.payload.opvcm;
            //console.log('Opvcm suite =>')
            //console.log(opvcm)
            set(opvcm);
        });

    return function stop() {
        console.log('opvcm coffre Store Stopped');
    };
});

